/**
 * roleUtils — 프론트 공통 역할 판정 SSoT
 *
 * ⚠ 서버 middleware/auth.js (authorize, L103~107) 역할 판정 미러 — 변경 시 양쪽 동기 필수.
 *
 * 판정 규칙 (백엔드와 동일):
 *  1. 관리자류 (system_admin / mold_developer / staff): **user_type 우선**
 *     — stale active_role 이 남아 있어도 관리 권한 유지 (백엔드 auth.js:104 동일)
 *  2. 협력사 (plant / maker): active_role || user_type
 *     — 겸업 협력사(capabilities=[plant,maker]) RoleChooserModal 전환 반영 (Phase K-M)
 *  3. staff → 'mold_developer' 매핑 (auth.js:107) — 호출처에 따라 opt-out 가능
 *     (예: MobileMore / MobileHomePage 는 'staff' 를 구분 값으로 사용)
 */

/** 관리자류 user_type — 서버 auth.js ADMIN_TYPES 미러 */
export const ADMIN_USER_TYPES = ['system_admin', 'mold_developer', 'staff']

/**
 * 사용자 객체에서 유효 역할(effective role) 판정
 *
 * @param {Object|null|undefined} user - authStore user (user_type, active_role)
 * @param {Object} [options]
 * @param {boolean} [options.mapStaff=true] - true 면 staff → 'mold_developer' 매핑 (auth.js:107 동일)
 * @param {string|null} [options.fallback=null] - user 없거나 역할 미확정 시 반환값
 * @returns {string|null} effective role ('system_admin'|'mold_developer'|'staff'|'plant'|'maker'|fallback)
 */
export function resolveEffectiveRole(user, { mapStaff = true, fallback = null } = {}) {
  if (!user) return fallback
  const rawRole = ADMIN_USER_TYPES.includes(user.user_type)
    ? user.user_type
    : (user.active_role || user.user_type)
  if (!rawRole) return fallback
  return mapStaff && rawRole === 'staff' ? 'mold_developer' : rawRole
}
